<template>
  <v-btn
    ref="btn"
    v-bind="{
      ...attrsFiltered.rest,
      onClick: disabledLocal ? undefined : attrsFiltered.onClick,
    }"
    :icon="!!icon && !buttonText"
    :aria-disabled="disabledLocal"
    :variant="variant || (link ? 'plain' : 'flat')"
    :ripple="!link"
    :class="{
      'v-btn--disabled': disabledLocal,
      'v-btn--link px-0!': link,
    }"
    @vue:mounted="renderTooltip = true"
  >
    <span class="flex items-center" :class="{ 'flex-row-reverse': iconRight }">
      <v-icon
        v-if="icon"
        :size="iconSize || (buttonText ? 18 : 22)"
        :start="!!buttonText && !iconRight"
        :end="!!buttonText && iconRight"
      >
        {{ icon }}
      </v-icon>
      {{ buttonText }}
    </span>
    <slot />
    <v-tooltip
      v-if="renderTooltip && disabledLocal"
      :activator="btn"
      v-bind="tooltip"
      :text="typeof disabled === 'string' && !!disabled ? disabled : 'Disabled'"
    />
  </v-btn>
</template>

<script setup>
import { computed, ref, useAttrs } from "vue";

defineOptions({ inheritAttrs: false });

const props = defineProps({
  buttonText: { type: String, default: null },
  icon: { type: String, default: null },
  variant: { type: String, default: null },
  disabled: { type: [String, Boolean], default: false },
  link: { type: Boolean, default: false },
  iconSize: { type: [String, Number], default: null },
  tooltip: { type: Object, default: () => ({ location: "top" }) },
  iconRight: { type: Boolean, default: false },
});

const renderTooltip = ref(false);
const btn = ref();
const disabledLocal = computed(
  () => (typeof props.disabled === "string" && props.disabled === "") || !!props.disabled,
);

const attrs = useAttrs();
const attrsFiltered = computed(() => {
  const { onClick, ...rest } = attrs;
  return { rest, onClick };
});
</script>

<style lang="scss" scoped>
:deep(.v-btn--disabled) {
  pointer-events: auto;
  cursor: not-allowed;

  img {
    filter: opacity(40%) saturate(0%) brightness(120%);
  }
}
:deep(.v-btn--link) {
  height: auto !important;
  color: #3096ed !important;
  font-weight: normal !important;
  padding: 0;
  min-width: 0 !important;
}
</style>
